/* eslint  @typescript-eslint/ban-ts-comment: 0 */ // --> OFF
import "jquery";
import "JSZip";
import "./kendo-ui-license.js";
import "@progress/kendo-ui";
import * as FilterTemplates from "../../Views/Shared/Grid/FilterTemplates";
import "./GlobalScripts/fileDownload";
//Widgets
import { MultiSelectPopup } from "../../Views/Shared/MultiSelectPopup";
import { YearlessDatePicker } from "../../Widgets/DatePicker/YearlessDatePicker";
import { DropDownMenu } from "../../Widgets/DropDownMenu/DropDownMenu";
import { OrphyEditor } from "../../Widgets/Editor/OrphyEditor";
import { MultiSelectWithAutoTransform } from "../../Widgets/MultiSelect/MultiSelectWithAutoTransform";
import { MultiSelectWithInsert } from "../../Widgets/MultiSelect/MultiSelectWithInsert";
//Global Scripts
import ButtonFunctions from "./GlobalScripts/ButtonFunctions";
import TelerikHelpers from "./GlobalScripts/TelerikHelpers";
import CommonFunctions from "./GlobalScripts/CommonFunctions";
import ValidationHelper from "./GlobalScripts/ValidationHelper";
import DropDownPlus from "./GlobalScripts/DropDownPlus";
import ContentDisposition from "./GlobalScripts/ContentDisposition";
import EditorToolFunctions from "./GlobalScripts/EditorToolFunctions";
import NewsletterTemplatePicker from "./GlobalScripts/NewsletterTemplatePicker";
import RecipientListWindow from "./GlobalScripts/RecipientListWindow";
import KendoTemplateLoader from "./GlobalScripts/KendoTemplateLoader";
import "./GlobalScripts/ReadOnlyLinkify";

const global = (window as any); 
global.FilterTemplates = FilterTemplates; //may move to grid
global.MultiSelectPopup = MultiSelectPopup;
global.YearlessDatePicker = YearlessDatePicker;
global.DropDownMenu = DropDownMenu;
global.OrphyEditor = OrphyEditor;
global.MultiSelectWithAutoTransform = MultiSelectWithAutoTransform;
global.MultiSelectWithInsert = MultiSelectWithInsert;
global.ButtonFunctions = ButtonFunctions;
global.TelerikHelpers = TelerikHelpers;
global.CommonFunctions = CommonFunctions;
global.ValidationHelper = ValidationHelper;
global.DropDownPlus = DropDownPlus;
global.ContentDisposition = ContentDisposition;
global.EditorToolFunctions = EditorToolFunctions;
global.NewsletterTemplatePicker = NewsletterTemplatePicker;
global.RecipientListWindow = RecipientListWindow;
global.KendoTemplateLoader = new KendoTemplateLoader();

//Widget Binders
global.kendo.data.binders.widget.multiselectwithautotransform = kendo.data.binders.widget.multiselect;
global.kendo.data.binders.widget.multiselectwithinsert = kendo.data.binders.widget.multiselect;

global.kendo.data.binders.strictInvisible = kendo.data.Binder.extend({
    refresh() {
        if (this.bindings.strictInvisible.get() === false) {
            this.element.style.display = "";
        } else {
            this.element.style.display = "none";
        }
    }
});

global.kendo.data.binders.visibleIfNot = kendo.data.Binder.extend({
    refresh() {
        const value = this.bindings.visibleIfNot.get();
        const notAllowedValue = this.element.getAttribute("data-visibleifnot");
        
        if (value != notAllowedValue) {
            $(this.element).show();
        } else {
            $(this.element).hide();
        }
    }
});

//kendo overrides
global.kendo.getWidgetFocusableElement_original = global.kendo.getWidgetFocusableElement;
global.kendo.getWidgetFocusableElement = (element) => {
    const instance = global.kendo.widgetInstance(element);
    if (instance && instance.options && instance.options.name && instance.options.name === "OrphyEditor") {
        return $(instance.body);
    }
    return global.kendo.getWidgetFocusableElement_original(element);
};

//kendo bug fix should be fixed in 2025 => https://github.com/telerik/kendo-ui-core/issues/8104

if (!global.kendo.ui.Menu.prototype._removeHoverItem) {
    global.kendo.ui.Menu.prototype._removeHoverItem = function removeHoverItem() { };
}

// Kendo leert den Suchtext nur beim Fokusverlust (_placeholder). Beim Auswählen per Klick oder
// Enter bleibt der Fokus im Input, der Suchtext steht also über dem geschlossenen Popup weiter da.
// Geleert wird deshalb erst in _close(): so verlieren Flows, die das Popup offen lassen
// (Ctrl+Space, autoClose: false), ihren noch gültigen Suchtext nicht.
const multiSelectSelect = global.kendo.ui.MultiSelect.fn._select;
global.kendo.ui.MultiSelect.fn._select = function (...args) {
    const selectedBefore = this.value().length;
    return multiSelectSelect.apply(this, args).done(() => {
        // Die Early-Returns von _select (Auswahllimit erreicht, select-Event abgebrochen) ändern
        // die Auswahl nicht - dann bleibt der Suchtext auch beim Schliessen stehen.
        this._obsoleteSearchText = this.value().length !== selectedBefore ? this.input.val() : null;
    });
};

const multiSelectClose = global.kendo.ui.MultiSelect.fn._close;
global.kendo.ui.MultiSelect.fn._close = function () {
    const obsoleteSearchText = this._obsoleteSearchText;
    this._obsoleteSearchText = null;
    // Nur leeren, wenn der Text seit der Auswahl unverändert ist: nach Ctrl+Space bleibt das Popup
    // offen, ein danach getippter Suchbegriff gehört nicht mehr zur abgeschlossenen Auswahl.
    const clearSearchText = typeof obsoleteSearchText === "string"
        && obsoleteSearchText === this.input.val();

    multiSelectClose.call(this);

    if (clearSearchText && this.options.autoClose) {
        this.input.val("");
        // _performSearch() sucht nur bei verändertem Text. Ohne _prev würde derselbe Begriff
        // nach dem Leeren kein erneutes Filtern auslösen.
        this._prev = "";
        // _toggleCloseVisibility() lief in _change() noch mit gefülltem Input: ohne diesen Aufruf
        // bliebe der Clear-Button stehen, wenn das letzte Element abgewählt wurde.
        this._toggleCloseVisibility();
    }
};
